import { StoreWallInterface } from "../../../../../../../store/types/store";
/**
 * Функция возвращает информацию о секции в указной стене
 * @param wall - стена
 * @returns { length, maxHeight, minHeight },
 * length - длина секции,
 * maxHeight - максима высота секции,
 * minHeight - минимальная высота всего стеллажа на стене
 */
export const getInfoSections = (wall: StoreWallInterface) => {
    let length = wall.sideIndent;
    let maxHeight = 0;
    let minHeight = 0;
    for (let q = 0; q < wall.sections.length; q++) {
        length += wall.sections[q].width;
        const minSectionHeight = Math.min(wall.sections[q].height, wall.sections[q].leftRackHeight);
        if (maxHeight < wall.sections[q].height) {
            maxHeight = wall.sections[q].height;
        }
        if (minHeight < minSectionHeight) {
            minHeight = minSectionHeight;
        }
    }
    maxHeight += wall.offsetCeiling;
    return { length, maxHeight, minHeight };
};
